import { withInstall } from '@xzx-design/utils'
import _Icon from './src/icon.vue'

export const Icon = withInstall(_Icon)
export default Icon

export * from './src/icon'
export * from './src/types'
